module.exports = __webpack_public_path__ + "img/winnings-weekly.42283f03.png";